import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";

const ModalWrapper = styled(Modal)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export function CancelConfirmationModal({ onCancel, open, onClose }) {
  return (
    <ModalWrapper
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="modal_container fit column">
        <p className="text_center">
          This action will erase all the data filled in the form.
          <br />
          Are you sure?
        </p>
        <div className="row center">
          <button className="btn ghost_outline_btn" onClick={onClose}>
            No
          </button>
          <button className="btn cta_btn" onClick={onCancel}>
            Yes
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
}
